import { useState, useEffect, useMemo } from 'react';
import {Checkbox} from '../reusableElementsComponents/Checkbox';
import ExplanationTooltip from '../reusableElementsComponents/ExplanationTooltip';
import B2BApiService from "../../B2bApiService";
// import {useSelector} from "react-redux";
import { t, lookups } from '../../content';


function NewPositionAssessmentsEdit ({ data, updateData, setPoolDataEditedFlag }) {
    // const contentfulData = useSelector(state => state.contentfulData.all['General definations']?.fields);
    const invalidInstruments = [111, 357, 315]
    const [allAssessments, setAllAssessments] = useState([]);
    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);

    const handleChange =  (e, value) => {
        if (e.target.checked) {
            updateData([...data, value.id]);
        } else {
            updateData(data.filter(id => id !== value.id));
        }
        setPoolDataEditedFlag(true);
    }

    useEffect(() => {
        if (!allAssessments.length) {
            b2bServiceObj.LoadAssessments(setAllAssessments);
        }
    }, [b2bServiceObj, allAssessments]);

    return (
        <div className="assessments-wrapper section">

            <p className='mar-20 bottom m bold'>
                Assessments
                <ExplanationTooltip>
                    <p>{t('recruitment.assessmentsInfo')}</p>
                </ExplanationTooltip>
            </p>
            <div className='assessment-card-wrapper'>
            {allAssessments &&
                allAssessments.map((assessment, index) => {
                    if (!invalidInstruments.includes(assessment.instrument)) {
                        return (
                            !assessment['is-custom-test'] &&
                            <div key={index} className='assessment-card'>
                                <Checkbox isChecked={data.includes(assessment.id)} onChange={(e) => { handleChange(e, assessment) }} />
                                <p className='m m-10 left'>
                                    {assessment.instrument === 102 && lookups.assessments['102']?.name}
                                    {assessment.instrument === 201 && lookups.assessments['201']?.name}
                                    {assessment.instrument === 302 && lookups.assessments['302']?.name}
                                    {assessment.instrument === 301 && lookups.assessments['301']?.name}
                                    {assessment.instrument === 344 && lookups.assessments['344']?.name}
                                    {assessment.instrument === 370 && lookups.assessments['370']?.name}
                                    {assessment.instrument === 390 && lookups.assessments['390']?.name}
                                    {assessment.instrument === 315 && assessment.name}
                                    <ExplanationTooltip>
                                        <p>
                                            {assessment.instrument === 102 && lookups.assessments['102']?.tooltip}
                                            {assessment.instrument === 201 && lookups.assessments['201']?.tooltip}
                                            {assessment.instrument === 302 && lookups.assessments['302']?.tooltip}
                                            {assessment.instrument === 301 && lookups.assessments['301']?.tooltip}
                                            {assessment.instrument === 344 && lookups.assessments['344']?.tooltip}
                                            {assessment.instrument === 370 && lookups.assessments['370']?.tooltip}
                                            {assessment.instrument === 390 && lookups.assessments['390']?.tooltip}
                                            {assessment.instrument === 315 && assessment.name}
                                        </p>
                                    </ExplanationTooltip>
                                </p>
                            </div>
                        )
                    } else {
                        return ""
                    }
                })
            }
            </div>
        </div>
    )
}

export default NewPositionAssessmentsEdit

